import { supabase } from '../config/supabase'

export const sendWelcomeEmail = async (userEmail, userName, options = {}) => {
  try {
    const { includeTempPassword = false, tempPassword = null, imageUrl: customImageUrl = null } = options
    
    // Construir la URL de la imagen
    const baseUrl = import.meta.env.VITE_SITE_URL || 'https://theunfilteredcollective.co'
    const defaultImageUrl = `${baseUrl}/img/EmailRegistro.jpeg`
    const imageUrl = customImageUrl || import.meta.env.VITE_EMAIL_IMAGE_URL || defaultImageUrl

    // Llamar a la Edge Function de Supabase en lugar de Resend directo
    // Asegurar que se incluya el token de autenticación si hay una sesión activa
    const { data, error } = await supabase.functions.invoke('send-welcome-email', {
      body: {
        email: userEmail,
        name: userName,
        includeTempPassword,
        tempPassword,
        imageUrl,
      },
      headers: {
        // El cliente de Supabase incluye automáticamente el Authorization header
        // si hay una sesión activa, pero lo especificamos explícitamente para asegurar
      }
    })

    if (error) {
      console.error('❌ Error llamando a send-welcome-email:', error)
      // Mostrar detalles del error siempre para diagnóstico
      console.error('Detalles del error:', {
        message: error.message,
        status: error.status,
        code: error.code,
        details: error
      })
      return { success: false, error }
    }

    console.log('✅ Respuesta de send-welcome-email:', data)
    return { success: true, data }
  } catch (err) {
    console.error('❌ Error invocando send-welcome-email:', err)
    if (process.env.NODE_ENV === 'development') {
      console.error('Detalles del error:', err)
    }
    return { success: false, error: err }
  }
}

export const sendNewsletterEmail = async (userEmail, newsletterContent) => {
  try {
    if (!resend) {
      console.warn('sendNewsletterEmail called but Resend is not configured. Skipping email send.')
      return { success: false, error: new Error('Resend API key not configured') }
    }

    const { data, error } = await resend.emails.send({
      from: 'The Unfiltered Collective <noreply@tudominio.com>',
      to: userEmail,
      subject: newsletterContent.subject || 'Newsletter - The Unfiltered Collective',
      html: newsletterContent.html
    })

    if (error) {
      console.error('Error sending newsletter:', error)
      return { success: false, error }
    }

    return { success: true, data }
  } catch (error) {
    console.error('Error sending newsletter:', error)
    return { success: false, error }
  }
}